// src/features/dashboard/hooks/Employee/useTopApplications.ts

import {
  useEffect,
  useState,
} from 'react';

import {
  getTopApplications,
} from '../../services/Employee/topApplications.service';

import {
  useDashboardDate,
} from '../../context/DashboardDateContext';

import {
  formatApiDate,
} from '../../utils/date.utils';

import type {
  TopApplicationsResponse,
} from '../../types/Employee/topApplications.types';

import { AuthSession } from '../../../../utils/authSession';

export const useTopApplications = () => {
  const employeeCode =
    AuthSession.currentEmployee();

  const {
    fromDate,
    toDate,
  } = useDashboardDate();

  const [
    data,
    setData,
  ] = useState<TopApplicationsResponse | null>(
    null,
  );

  const [
    loading,
    setLoading,
  ] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      /*
       * Employee code is required.
       */
      if (!employeeCode) {
        setData(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        /*
         * Clear previous day's data while
         * the new date range is loading.
         */
        setData(null);

        const response =
          await getTopApplications({
            employeeCode,

            fromDate:
              formatApiDate(
                fromDate,
              ),

            toDate:
              formatApiDate(
                toDate,
              ),
          });

        setData(
          response ?? null,
        );
      } catch (error) {
        console.error(
          'Top Applications Error:',
          error,
        );

        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    employeeCode,
    fromDate,
    toDate,
  ]);

  return {
    data,
    loading,
  };
};